'use strict';

const dateInputTokens = (theme) => ({
    dateInputOverlayMaxWidth: '20rem',
    dateInputOverlayPaddingX: theme.space.component.x.m,
    dateInputOverlayPaddingY: theme.space.component.y.m,
});

exports.dateInputTokens = dateInputTokens;
//# sourceMappingURL=dateInput.js.map
